<template>
  <div class="ma-4 px-4">
    <v-tabs v-model="activeTab" grow class="px-3">
      <v-tab v-for="tab in tabs" :key="tab.key" class="text-none">
        <v-icon active left small>{{ tab.icon }}</v-icon>
        {{ tab.title }}
      </v-tab>
    </v-tabs>

    <v-divider></v-divider>

    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <DebUpdate ref="debUpdate" />
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text class="pa-4">
            <div class="text-caption text-medium-emphasis mb-3">
              <v-icon small class="mr-1">mdi-information-outline</v-icon>
              Search applicant to set zero advance payment
            </div>
            <v-form @submit.prevent="getPreApplicant" class="compact-form">
              <v-row dense align="end">
                <v-col cols="12" sm="8" md="3">
                  <template v-if="zeroPaymentSearch.filterBy === 'unique_id'">
                    <v-text-field
                      v-model="zeroPaymentSearch.unique_id"
                      label="Unique ID"
                      dense
                      outlined
                      hide-details
                      maxlength="6"
                      clearable
                      placeholder="Enter Unique ID"
                    ></v-text-field>
                  </template>
                </v-col>

                <v-col cols="12" sm="12" md="3">
                  <v-btn
                    color="primary"
                    type="submit"
                    class="text-none"
                    :loading="loading"
                    :disabled="!hasZeroPaymentSearch"
                  >
                    <v-icon left small>mdi-magnify</v-icon>
                    Search
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="applicantData?.unique_id">
                <v-col cols="3">
                  <v-text-field
                    v-model="applicantData.name"
                    label="Name"
                    dense
                    readonly
                    hide-details
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="applicantData.email"
                    label="Email"
                    dense
                    hide-details
                    readonly
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="applicantData.mobile_no"
                    label="Mobile Number"
                    dense
                    hide-details
                    readonly
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="d-flex justify-center pt-3">
                <v-btn
                  color="primary"
                  :loading="paymentLoader"
                  v-if="applicantData?.advance_fee_paid == 'N'"
                  @click="setZeroPayment()"
                  >Set Zero Payment
                </v-btn>
                <v-col
                  cols="12"
                  class="d-flex justify-center"
                  v-if="applicantData?.advance_fee_paid == 'Y'"
                >
                  The payment process has been completed.
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <personal-details ref="personalDetails"></personal-details>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text class="pa-4">
            <div class="text-caption text-medium-emphasis mb-3">
              <v-icon small class="mr-1">mdi-information-outline</v-icon>
              Search {{ directPaymentSearch.entryType === 'admission' ? 'applicant' : 'student' }} to enter direct payment details.
            </div>
            <v-form ref="directPayment" @submit.prevent="handleDirectPaymentSearch">
              <v-row dense align="end">
                <!-- <v-col cols="12" sm="6" md="3">
                  <v-select
                    v-model="directPaymentSearch.entryType"
                    :items="entryTypes"
                    item-text="name"
                    item-value="id"
                    label="Admission/Academic"
                    dense
                    outlined
                    hide-details
                    @change="resetDirectPaymentSearch"
                  ></v-select>
                </v-col> -->

                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  v-if="directPaymentSearch.entryType === 'academic'"
                >
                  <v-select
                    v-model="directPaymentSearch.paymentType"
                    :items="paymentTypes"
                    item-text="name"
                    item-value="id"
                    label="Payment Type"
                    dense
                    outlined
                    hide-details
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-if="directPaymentSearch.entryType === 'admission'"
                    v-model="directPaymentSearch.application_id"
                    label="Application ID"
                    dense
                    outlined
                    hide-details
                    clearable
                    :rules="[rules.required]"
                  ></v-text-field>
                  <v-text-field
                    v-else
                    v-model="directPaymentSearch.usn_id"
                    label="USN"
                    dense
                    outlined
                    maxlength="11"
                    hide-details
                    clearable
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <v-btn
                    color="primary"
                    type="submit"
                    class="text-none"
                    :disabled="
                      directPaymentSearch.entryType === 'admission'
                        ? !directPaymentSearch.application_id
                        : !directPaymentSearch.usn_id
                    "
                    :loading="loading"
                  >
                    <v-icon left small>mdi-magnify</v-icon>
                    Search
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Admission direct payment entry -->
              <v-row v-if="directPaymentSearch.entryType === 'admission' && admissionApplicantData.id">
                <v-col cols="3">
                  <v-text-field
                    v-model="admissionApplicantData.name"
                    label="Name"
                    dense
                    readonly
                    hide-details
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="admissionApplicantData.email"
                    label="Email"
                    dense
                    hide-details
                    readonly
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="admissionApplicantData.mobile_no"
                    label="Mobile Number"
                    dense
                    hide-details
                    readonly
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model.number="directPaymentSearch.amount"
                    label="Amount"
                    dense
                    prefix="₹"
                    hide-details
                    outlined
                    :rules="[
                      rules.required,
                      (v) =>
                        v <= admissionApplicantData.plan_amount_balance ||
                        `Amount cannot exceed ₹${admissionApplicantData.plan_amount_balance}`,
                    ]"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-menu
                    v-model="paymentDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        outlined
                        dense
                        hide-details
                        :rules="[rules.required]"
                        label="Payment Date"
                        append-icon="mdi-calendar"
                        :value="formattedTransactionDate"
                      />
                    </template>

                    <v-date-picker
                      v-model="directPaymentSearch.transaction_date"
                      no-title
                      :max="minDate"
                      @change="paymentDateMenu = false"
                    />
                  </v-menu>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="directPaymentSearch.transaction_id"
                    label="Transaction ID"
                    dense
                    hide-details
                    outlined
                    :rules="[rules.required]"
                    @input="
                      directPaymentSearch.transaction_id =
                        directPaymentSearch.transaction_id.toUpperCase()
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row
                class="d-flex justify-center pt-3"
                v-if="
                  directPaymentSearch.entryType === 'admission' &&
                  admissionApplicantData.id &&
                  admissionApplicantData.plan_amount_balance > 0
                "
              >
                <v-btn
                  color="primary"
                  :loading="paymentLoader"
                  @click="setAdmissionPayment"
                  ><v-icon>mdi-lock</v-icon> Update
                </v-btn>
              </v-row>
              <v-row
                v-if="
                  directPaymentSearch.entryType === 'admission' &&
                  admissionApplicantData.id &&
                  admissionApplicantData.plan_amount_balance <= 0
                "
              >
                <v-col cols="12" class="d-flex justify-center">
                  The payment process has already been successfully completed.
                </v-col>
              </v-row>

              <!-- Academic: multiple pending invoices found, let user pick one -->
              <v-row
                v-if="
                  directPaymentSearch.entryType === 'academic' &&
                  pendingInvoices.length > 1
                "
              >
                <v-col cols="12">
                  <div class="text-caption text-medium-emphasis mb-2">
                    Multiple pending invoices found. Select the invoice to pay.
                  </div>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>Type</th>
                          <th>Term No</th>
                          <th>Amount</th>
                          <th>Raised Batch</th>
                          <th>Due Date</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="invoice in pendingInvoices"
                          :key="invoice.invoice_id"
                        >
                          <td>{{ invoice.type }}</td>
                          <td>{{ invoice.term_no }}</td>
                          <td>₹{{ invoice.amount }}</td>
                          <td>{{ invoice.fee_raised_batch }}</td>
                          <td>{{ invoice.due_date }}</td>
                          <td>
                            <v-btn
                              x-small
                              color="primary"
                              text
                              class="text-none"
                              @click="selectInvoice(invoice)"
                            >
                              Select
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>

              <!-- Academic direct payment entry -->
              <v-row
                v-if="
                  directPaymentSearch.entryType === 'academic' &&
                  (applicantData?.status == 'Due' ||
                  (applicantData?.status == 'Pending' && applicantData?.usn_id))
                "
              >
                <v-col cols="3">
                  <v-text-field
                    v-model="applicantData.name"
                    label="Name"
                    dense
                    readonly
                    hide-details
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="applicantData.email"
                    label="Email"
                    dense
                    hide-details
                    readonly
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="applicantData.mobile_no"
                    label="Mobile Number"
                    dense
                    hide-details
                    readonly
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="applicantData.fee_raised_batch"
                    label="Raised Batch"
                    dense
                    hide-details
                    readonly
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="directPaymentSearch.amount"
                    label="Amount"
                    dense
                    prefix="₹"
                    readonly
                    hide-details
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-menu
                    v-model="paymentDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        outlined
                        dense
                        hide-details
                        :rules="[rules.required]"
                        label="Transaction Date"
                        append-icon="mdi-calendar"
                        :value="formattedTransactionDate"
                      />
                    </template>

                    <v-date-picker
                      v-model="directPaymentSearch.transaction_date"
                      no-title
                      :max="minDate"
                      @change="paymentDateMenu = false"
                    />
                  </v-menu>
                </v-col>
                <v-col cols="3">
                  <v-menu
                    v-model="paymentTimeMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        outlined
                        dense
                        hide-details
                        :rules="[rules.required]"
                        label="Transaction Time"
                        append-icon="mdi-clock"
                        :value="formattedTransactionTime"
                      />
                    </template>

                    <v-time-picker
                      v-model="directPaymentSearch.transaction_time"
                      format="24hr"
                      @change="paymentTimeMenu = false"
                    />
                  </v-menu>
                </v-col>

                <v-col cols="3">
                  <v-text-field
                    v-model="directPaymentSearch.transaction_id"
                    label="UTR Number"
                    dense
                    hide-details
                    outlined
                    :rules="[rules.required]"
                    @input="
                      directPaymentSearch.transaction_id =
                        directPaymentSearch.transaction_id.toUpperCase()
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row
                class="d-flex justify-center pt-3"
                v-if="
                  directPaymentSearch.entryType === 'academic' &&
                  (applicantData?.status == 'Due' ||
                  (applicantData?.status == 'Pending' && applicantData?.usn_id))
                "
              >
                <v-btn
                  color="primary"
                  :loading="paymentLoader"
                  @click="setDirectPayment"
                  ><v-icon>mdi-lock</v-icon> Update
                </v-btn>
              </v-row>
              <v-row
                v-if="
                  directPaymentSearch.entryType === 'academic' &&
                  (applicantData?.status == 'Paid' ||
                  (applicantData?.status == 'Completed' &&
                    applicantData?.usn_id))
                "
              >
                <v-col cols="12" class="d-flex justify-center">
                  The payment process has already been successfully completed.
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text class="pa-4">
            <div class="text-caption text-medium-emphasis mb-3">
              <v-icon small class="mr-1">mdi-information-outline</v-icon>
              Search for USN and upload the image.
            </div>
            <v-form
              ref="uploadImage"
              class="compact-form"
              @submit.prevent="getUSNData('profile')"
            >
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="uploadImage.usn_id"
                    label="USN"
                    dense
                    outlined
                    hide-details
                    clearable
                    maxlength="11"
                    :rules="[rules.required]"
                    @clear="profilePreview = null"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="3">
                  <v-btn
                    color="primary"
                    type="submit"
                    class="text-none"
                    :loading="loading"
                    :disabled="
                      !uploadImage.usn_id
                    "
                  >
                    <v-icon left small>mdi-magnify</v-icon>
                    Search
                  </v-btn>
                </v-col>
              </v-row>

              <v-row
                v-if="showImagePreview"
                class="mt-2"
                justify="center"
                align="center"
              >
                <!-- LEFT: IMAGE PREVIEW -->
                <v-col
                  cols="12"
                  md="4"
                  class="d-flex justify-center"
                  v-if="profilePreview"
                >
                  <v-card
                    class="pa-4 d-flex align-center justify-center"
                    elevation="4"
                    outlined
                    height="300"
                    width="300"
                    style="border-radius: 12px"
                  >
                    <v-img
                      v-if="profilePreview"
                      :src="profilePreview"
                      contain
                      max-width="280"
                      max-height="280"
                      style="border-radius: 8px"
                    ></v-img>

                    <div v-else class="text-center grey--text text--darken-1">
                      <v-icon size="48" class="mb-4">mdi-account-circle</v-icon>
                      <div class="text-subtitle-1">No Profile Image</div>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" md="6">
                  <v-card
                    class="px-6 py-3"
                    elevation="4"
                    style="border-radius: 12px; border: 2px dashed #e0e0e0"
                    :class="{ 'upload-active': isDraggingOver }"
                    @dragover.prevent="isDraggingOver = true"
                    @dragleave="isDraggingOver = false"
                    @drop.prevent="handleDrop"
                  >
                    <div class="text-h6 font-weight-medium primary--text">
                      {{
                        imageNotFound
                          ? "Upload Profile Image"
                          : "Replace Profile Image"
                      }}
                    </div>

                    <div class="text-caption grey--text mb-2">
                      {{
                        imageNotFound
                          ? "Add a profile image for this user"
                          : "Update the existing profile image"
                      }}
                    </div>

                    <!-- Upload Area -->
                    <div
                      class="upload-zone pa-2 text-center"
                      @click="$refs.fileInput.click()"
                      :class="{ 'upload-zone-hover': isDraggingOver }"
                      style="
                        border: 2px dashed #1976d2;
                        border-radius: 8px;
                        background-color: #f8fbff;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        min-height: 140px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <v-icon
                        size="48"
                        color="primary"
                        class="mb-2"
                        :class="{ 'animate-pulse': isDraggingOver }"
                      >
                        {{
                          isDraggingOver ? "mdi-cloud-upload" : "mdi-image-plus"
                        }}
                      </v-icon>

                      <div class="text-subtitle-1 font-weight-medium mb-1">
                        {{
                          uploadImage.file
                            ? uploadImage.file.name.length > 30
                              ? uploadImage.file.name.slice(0, 30) + "..."
                              : uploadImage.file.name
                            : "Drag & Drop or Click to Upload"
                        }}
                      </div>

                      <div class="text-caption grey--text">
                        {{
                          uploadImage.file
                            ? `Size: ${(uploadImage.file.size / 1024).toFixed(
                                2,
                              )} KB`
                            : "Supports JPG, PNG (Max 5MB)"
                        }}
                      </div>

                      <input
                        type="file"
                        ref="fileInput"
                        accept="image/*"
                        style="display: none"
                        @change="handleFileSelect"
                      />
                    </div>

                    <!-- Uploaded File Info -->
                    <v-card
                      v-if="uploadImage.file"
                      class="mt-2 pa-3"
                      style="
                        border-left: 4px solid #4caf50;
                        background-color: #f9f9f9;
                      "
                    >
                      <v-row align="center">
                        <v-col cols="auto">
                          <v-icon color="success">mdi-check-circle</v-icon>
                        </v-col>
                        <v-col>
                          <div class="text-body-2 font-weight-medium">
                            {{
                              uploadImage.file.name.length > 30
                                ? uploadImage.file.name.slice(0, 30) + "..."
                                : uploadImage.file.name
                            }}
                          </div>
                          <div class="text-caption grey--text">
                            {{ (uploadImage.file.size / 1024).toFixed(2) }} KB •
                            Ready to upload
                          </div>
                        </v-col>
                        <v-col cols="auto">
                          <v-btn
                            icon
                            small
                            @click="uploadImage.file = null"
                            color="grey"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>

                    <!-- Upload Button -->
                    <v-btn
                      color="primary"
                      class="mt-4 text-none"
                      block
                      @click="uploadProfileFile"
                      :disabled="!uploadImage.file"
                      :loading="uploading"
                      size="large"
                      style="border-radius: 8px; height: 48px"
                    >
                      <v-icon left>mdi-cloud-upload-outline</v-icon>
                      {{
                        uploading
                          ? "Uploading..."
                          : imageNotFound
                          ? "Upload Image"
                          : "Update Image"
                      }}
                    </v-btn>

                    <div class="mt-4 text-caption grey--text">
                      <v-icon x-small color="grey" class="mr-1"
                        >mdi-information</v-icon
                      >
                      Recommended: Square image, at least 500×500 pixels, max
                      5MB
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item> <setConcession /> </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import personalDetails from "@/components/updateApplicants/personalDetails.vue";
import DebUpdate from "@/components/updateApplicants/DebUpdate.vue";
import setConcession from "@/components/SetConcessionPayment.vue";
import { rules } from "@/helpers/rules";
export default {
  components: { personalDetails, setConcession, DebUpdate },
  data() {
    return {
      rules,
      activeTab: 0,
      tabs: [
        {
          key: "update-deb-abc",
          title: "Update Applicant",
          icon: "mdi-id-card",
        },
        {
          key: "zero-payment",
          title: "Set Zero Advance Payment",
          icon: "mdi-cash-remove",
        },
        { key: "personal", title: "Personal Info", icon: "mdi-account-edit" },
        {
          key: "direct-payment",
          title: "Direct Payment Entry",
          icon: "mdi-cash-plus",
        },
        {
          key: "upload-image",
          title: "Upload Image",
          icon: "mdi-upload",
        },
        {
          key: "set-concession",
          title: "Set Concession",
          icon: "mdi-percent",
        },
      ],

      zeroPaymentSearch: {
        filterBy: "unique_id",
        unique_id: "",
      },
      applicantData: {},
      uploadImage: {
        usn_id: "",
        file: null,
      },
      paymentTypes: [
        { id: "Exam Fee", name: "Exam Fee" },
        { id: "Term Fee", name: "Term Fee" },
        { id: "Convocation Fee", name: "Convocation Fee" },
        { id: "Re-Admission Fee", name: "Re-Admission Fee" },
        { id: "Postal Fee", name: "Postal Fee" },
        { id: "Annual", name: "Annual Fee" },
      ],
      entryTypes: [
        { id: "academic", name: "Academic" },
        { id: "admission", name: "Admission" },
      ],
      directPaymentSearch: {
        entryType: "academic",
        paymentType: "Exam Fee",
        usn_id: "",
        application_id: "",
        transaction_date: null,
        transaction_time: null,
        transaction_id: null,
        amount: null,
      },
      admissionApplicantData: {},
      pendingInvoices: [],
      paymentDatePicker: false,
      paymentDateMenu: false,
      paymentTimeMenu: false,
      loading: false,
      paymentLoader: false,
      profilePreview: null,
      imageNotFound: false,
      isDraggingOver: false,
      uploading: false,
      menu: false,
      showImagePreview: false,
    };
  },
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Info Updates" }]);
  },
  watch: {
    menu(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.dobPicker) {
            this.$refs.dobPicker.activePicker = "YEAR";
          }
        });
      }
    },
  },
  computed: {
    hasZeroPaymentSearch() {
      return (
        this.zeroPaymentSearch.unique_id &&
        this.zeroPaymentSearch.unique_id.length >= 6
      );
    },
    minDate() {
      return new Date().toISOString().substr(0, 10);
    },
    hasDirectPaymentSearch() {
      return (
        this.directPaymentSearch.paymentType && this.directPaymentSearch.usn_id
      );
    },
    formattedTransactionDate() {
      if (!this.directPaymentSearch.transaction_date) return "";
      return this.directPaymentSearch.transaction_date;
    },

    formattedTransactionTime() {
      if (!this.directPaymentSearch.transaction_time) return "";
      return this.directPaymentSearch.transaction_time;
    },
    formattedDob() {
      if (!this.applicantData.dob) return "";
      const [year, month, day] = this.applicantData.dob.split("-");
      return `${day}-${month}-${year}`;
    },
    sixteenYearsAgo() {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 10);
      date.setMonth(11);
      date.setDate(31);
      return date.toISOString().substr(0, 10);
    },
    hundredYearsAgo() {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 100);
      date.setMonth(0);
      date.setDate(1);
      return date.toISOString().substr(0, 10);
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
  },
  methods: {
    async searchPersonal() {
      console.log("Searching Personal Updates:", this.personalSearch);
      const res = await this.$axios.get(
        `/get_student_info_by_usn_id/${this.personalSearch.identifier}`,
      );

      this.applicantData = res.data.data;
    },
    objectToQueryParams(obj) {
      return Object.keys(obj)
        .filter(
          (key) =>
            obj[key] !== undefined && obj[key] !== null && obj[key] !== "",
        )
        .map(
          (key) => encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]),
        )
        .join("&");
    },

    resetSearch() {
      this.zeroPaymentSearch = {
        unique_id: "",
      };
    },
    async getPreApplicant() {
      const queryString = this.objectToQueryParams({
        ...this.zeroPaymentSearch,
      });
      try {
        this.loading = true;
        const res = await this.$axios.get(`pre_applications?${queryString}`);
        this.applicantData = res.data.data[0];
        if (res.data.data.length === 0) {
          this.$store.commit("showSnackbar", {
            message: "Invalid Unique Id",
            color: "error",
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    resetDirectPaymentSearch() {
      this.applicantData = {};
      this.admissionApplicantData = {};
      this.pendingInvoices = [];
      this.directPaymentSearch.usn_id = "";
      this.directPaymentSearch.application_id = "";
      this.directPaymentSearch.transaction_date = null;
      this.directPaymentSearch.transaction_time = null;
      this.directPaymentSearch.transaction_id = null;
      this.directPaymentSearch.amount = null;
    },

    async handleDirectPaymentSearch() {
      if (this.directPaymentSearch.entryType === "admission") {
        await this.getAdmissionPlanData();
      } else {
        await this.getUSNData("direct");
      }
    },

    async getAdmissionPlanData() {
      this.loading = true;
      this.admissionApplicantData = {};
      try {
        const res = await this.$axios.get(
          `/get_student_admit_plan_by_application_id/${this.directPaymentSearch.application_id}`,
        );
        this.admissionApplicantData = res.data.data;
        this.directPaymentSearch.amount = this.admissionApplicantData.plan_amount_balance;
        this.directPaymentSearch.transaction_date = null;
        this.directPaymentSearch.transaction_id = null;
      } catch (error) {
        this.$store.commit("showSnackbar", {
          message: "Invalid Application ID",
          color: "error",
        });
      } finally {
        this.loading = false;
      }
    },

    async setAdmissionPayment() {
      if (!this.$refs.directPayment.validate()) return;
      this.paymentLoader = true;
      const data = {
        student_admit_plan_id: this.admissionApplicantData.id,
        payment_date: this.directPaymentSearch.transaction_date,
        payment_amount: this.directPaymentSearch.amount,
        paid_by: "STUDENT",
        transaction_id: this.directPaymentSearch.transaction_id,
        mode: "Direct",
        created_by: this.currentUser.email,
      };
      try {
        await this.$axios.post("/student_admit_plan_payments", {
          student_admit_plan_payment: data,
        });
        this.$store.commit("showSnackbar", {
          message: "Payment success",
          color: "success",
        });
        await this.getAdmissionPlanData();
      } catch (error) {
        const errors = error.response?.data?.errors;
        const firstError =
          errors && typeof errors === "object"
            ? Object.values(errors)[0]?.[0]
            : null;
        this.$store.commit("showSnackbar", {
          message: firstError || "Payment failed",
          color: "error",
        });
      } finally {
        this.paymentLoader = false;
      }
    },

    async searchDirectPayment() {
      this.applicantData = {};
      this.pendingInvoices = [];
      this.loading = true;
      await this.$axios
        .get(
          `/list_student_invoices_report?usn_id=${this.directPaymentSearch.usn_id}&type=${this.directPaymentSearch.paymentType}&status=Pending`,
        )
        .then((res) => {
          const invoices = res.data.data;
          if (invoices.length === 0) {
            this.$store.commit("showSnackbar", {
              message: "No Payment Found for the USN",
              color: "error",
            });
          } else if (invoices.length === 1) {
            this.selectInvoice(invoices[0]);
          } else {
            this.pendingInvoices = invoices;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    selectInvoice(invoice) {
      this.applicantData = invoice;
      this.directPaymentSearch.amount = invoice?.amount;
      this.directPaymentSearch.transaction_date = null;
      this.directPaymentSearch.transaction_time = null;
      this.directPaymentSearch.transaction_id = null;
      this.pendingInvoices = [];
    },

    async setZeroPayment() {
      this.paymentLoader = true;
      await this.$axios
        .put(`/set_zero_advance_fee/${this.zeroPaymentSearch.unique_id}`)
        .then((res) => {
          this.$store.commit("showSnackbar", {
            message: "Updated Successfully",
            color: "success",
          });
        })
        .finally(() => {
          this.getPreApplicant();
          this.paymentLoader = false;
        });
    },

    getOrderId() {
      return new Date().getTime().toString();
    },

    async setDirectPayment() {
      if (!this.$refs.directPayment.validate()) return;
      this.submitting = true;
      this.paymentLoader = true;
      const transactionDateTime = this.formatToBilldeskDateTime(
        this.directPaymentSearch.transaction_date,
        this.directPaymentSearch.transaction_time,
      );
      const data = {
        payment_detail: this.directPaymentSearch.paymentType,
        application_id: this.applicantData.usn_id,
        objectid: "transaction",
        transactionid: this.directPaymentSearch.transaction_id,
        orderid: this.getOrderId(),
        mercid: "Direct",
        transaction_date: transactionDateTime,
        amount: this.applicantData.amount,
        surcharge: "0.00",
        discount: "0.00",
        charge_amount: this.applicantData.amount,
        currency: "356",
        additional_info: {
          additional_info2: this.applicantData.usn_id,
          additional_info3: this.directPaymentSearch.paymentType,
          additional_info4: this.applicantData.term_no,
          additional_info5: this.applicantData.student_detail_id,
          additional_info6: this.applicantData.invoice_id,
        },
        ru: "https://cnb-api.vidya-realm.com/api/billdesk_payments/fee_collection",
        txn_process_type: "intent",
        bankid: "KT5",
        itemcode: "DIRECT",
        bank_ref_no: "",
        auth_status: "0300",
        transaction_error_code: "TRS0000",
        transaction_error_desc: "Transaction Successful",
        transaction_error_type: "success",
        payment_method_type: "Direct Payment",
        payment_category: "10",
        split_payment: [
          {
            mercid: "CUBSASONL1",
            amount: this.applicantData.amount,
          },
        ],
      };
      const response = await this.$axios.post(
        "/student_invoice_direct_payment",
        data,
      );
      if (response.data.data == "Success") {
        this.paymentLoader = false;
        this.searchDirectPayment();
        this.$store.commit("showSnackbar", {
          message: "Payment success",
          color: "success",
        });
      }
    },

    formatToBilldeskDateTime(date, time) {
      if (!date || !time) return null;
      const dt = new Date(`${date}T${time}:00`);
      const formatted = `${date}T${time}:00+05:30`;
      return formatted;
    },

    async uploadProfileFile() {
      const formData = new FormData();
      formData.append("file", this.uploadImage.file);
      this.uploading = true;

      try {
        await this.$axios.put(
          `/upload_profile_image/${this.uploadImage.usn_id}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } },
        );

        this.$store.commit("showSnackbar", {
          message: "Image Uploaded successfully",
          color: "success",
        });
        this.uploading = false;

        this.getProfileImage();
      } catch (err) {
        this.$store.commit("showSnackbar", {
          message: "Image Upload failed",
          color: "error",
        });
      }
    },
    async getProfileImage() {
      this.showImagePreview = false;
      this.imageNotFound = false;
      this.profilePreview = null;
      this.loading = true;
      try {
        const res = await this.$axios.get(
          `/get_profile_image/${this.uploadImage.usn_id}`,
          {
            responseType: "blob",
          },
        );
        this.profilePreview = URL.createObjectURL(res.data);
        this.uploadImage.file = null;
      } catch (err) {
        console.log(err.response);
        if (err.response && err.response.status === 404) {
          this.imageNotFound = true;
          this.$store.commit("showSnackbar", {
            message: "Image not found",
            color: "error",
          });
        }
      }
      this.loading = false;
      this.showImagePreview = true;
    },
    async getUSNData(type) {
      this.loading = true;
      this.showImagePreview = false;
      this.applicantData = {};
      this.pendingInvoices = [];
      let usn_id = null;
      if (type == "profile") usn_id = this.uploadImage.usn_id;
      if (type == "direct") usn_id = this.directPaymentSearch.usn_id;
      await this.$axios
        .get(`get_student_info_by_usn_id/${usn_id}`)
        .then((res) => {
          if (type == "profile") this.getProfileImage();
          if (type == "direct") this.searchDirectPayment();
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.error,
            color: "error",
          });
          this.loading = false;
        });
    },
    handleFileSelect(event) {
      const file = event.target.files[0];
      if (file && file.type.startsWith("image/")) {
        if (file.size > 5 * 1024 * 1024) {
          this.$store.commit("showSnackbar", {
            message: "File size must be less than 5MB",
            color: "error",
          });
          return;
        }
        this.uploadImage.file = file;
        this.previewImage(file);
      }
      this.isDraggingOver = false;
    },

    handleDrop(event) {
      event.preventDefault();
      const file = event.dataTransfer.files[0];
      if (file && file.type.startsWith("image/")) {
        if (file.size > 5 * 1024 * 1024) {
          this.$store.commit("showSnackbar", {
            message: "File size must be less than 5MB",
            color: "error",
          });
          return;
        }
        this.uploadImage.file = file;
        this.previewImage(file);
      }
      this.isDraggingOver = false;
    },

    previewImage(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.profilePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    currentDate(date) {
      const d = new Date(date);
      let month = "" + (d.getMonth() + 1);
      let day = "" + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
  },
};
</script>

<style scoped>
/* Compact card styling */
.v-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.v-card-title {
  font-size: 1.1rem;
  font-weight: 500;
}

/* Compact tab styling */
.v-tab {
  font-size: 0.85rem;
  min-width: 120px;
  padding: 0 12px;
  margin: 0 4px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .compact-form {
    padding: 12px;
  }

  .v-col {
    padding: 6px 8px;
  }
}

@media (max-width: 600px) {
  .v-tab {
    min-width: 100px;
    font-size: 0.8rem;
  }

  .v-card-title {
    font-size: 1rem;
    padding: 12px;
  }
}

/* Hover effects */
.v-btn:hover {
  transform: translateY(-1px);
  transition: transform 0.2s;
}

/* Icon colors */
.v-icon {
  color: rgba(0, 0, 0, 0.6);
}

.upload-zone-hover {
  background-color: #e3f2fd !important;
  border-color: #1976d2 !important;
  transform: scale(1.01);
}

.upload-active {
  border-color: #1976d2 !important;
}

.animate-pulse {
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.v-card.upload-active {
  transition: border-color 0.3s ease;
}
</style>
